import { Page } from '../../types';
import { DEPARTMENTS, CHILD_ORGS } from '../../defaultContent';

const pointsOfContact: Page[] = [
  {
    pageType: 'question',
    title: 'Department Select',
    name: 'department-select',
    questions: [
      {
        questionType: 'select',
        title: 'Please select your area',
        name: 'parent-dept',
        options: DEPARTMENTS,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'radio',
        title: 'Is this submission for an Executive Agency, Arms Length Body, Non Departmental Public Body or other entity which sits under an overarching government department?',
        hint: 'Select No if this submission is for the core department',
        name: 'child-dept-radio',
        options: [
          {
            option: 'Yes',
            questions: [
              {
                questionType: 'select',
                title: 'Please select your area',
                name: 'child-dept',
                options: CHILD_ORGS,
                rules: {
                  required: true,
                },
              },
            ],
          },
          'No',
        ],
        rules: {
          required: true,
        },
      },
    ],
  },
  {
    pageType: 'list',
    title: 'Points of contact',
    name: 'points-of-contact',
    description:
      'Enter all of your current phone numbers. You must enter at least one phone number and one email address. <br><br> The phone numbers you provide must be direct numbers where we can contact you, not a switchboard or shared number. <br><br> You can enter the same email address you used when registering as well as different ones if you have alternative email addresses.',
    questions: [
      {
        questionType: 'textInput',
        title: 'Name',
        name: 'points-of-contact-name',
        hint: 'Please enter your full name.',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Email address',
        name: 'points-of-contact-email',
        hint: 'Please enter your current Email addresses.',
        rules: {
          required: true,
          email: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Telephone',
        name: 'points-of-contact-telephone',
        hint: 'Please enter your current Telephone number.',
        detailsContent:
          'For example for UK phone numbers, 07700900789 for mobile or 01632960789 for landline. For International numbers include the country code for example +447388123456.',
        rules: {
          required: true,
          telephone: true,
        },
      },
    ],
  },
]

export default pointsOfContact;
